
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

export default {
  name: 'WechatAuthView',
  setup() {
    const router = useRouter()
    const { t } = useI18n()
    const loading = ref(false)

    const goBack = () => {
      router.go(-1)
    }

    const handleWechatAuth = async () => {
      loading.value = true
      try {
        // 跳转到微信登录二维码页面
        const wechatLoginUrl = 'https://test6-gw.cbim.org.cn/cbim-uc/wechat/login/qrcode?redirectURL=https://test6.cbim.org.cn'
        window.location.href = wechatLoginUrl
      } catch (error) {
        loading.value = false
        console.error('微信授权失败:', error)
      }
    }

    return {
      loading,
      goBack,
      handleWechatAuth
    }
  }
}
